// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Yzd53","label":"CategoryService_label__288wj","location":"CategoryService_location__3B94h"};